import { listenToWindowEvents } from './listenToWindowEvents';
import type { StorageEventsHandler } from './StorageEventsHandler';
import { createStorageEventsHandler as createStorageEventsHandlerBase } from './StorageEventsHandler';

export function createStorageEventsHandler(storage: Storage | undefined): StorageEventsHandler {
	const handler = createStorageEventsHandlerBase();
	storage && listenToWindowEvents(handler, storage);
	return handler;
}
